<template>
    <div class="micro-page-data">
      <el-row class="search-title common-table-top" style="margin-top: 20px">
        <el-col :span="4" class="table-title" style="text-align: left">
          <i class="el-icon-document" style="font-weight: bold;"></i>
          <span>数据列表</span>
        </el-col>
        <el-col :span="20" class="text-align-right">
          <el-button class="add-btn" type="primary" size="small" style="margin-left: 0" @click="downloadNow">导出</el-button>
        </el-col>
      </el-row>
      <el-table
        :data="scenedatalist"
        style="background: #EDEFF7">
        <template slot="empty">
          <div class="newTableEmpty">没有更多数据了</div>
        </template>
        <el-table-column :label="data.name" v-for="data in headerList" :key="data.id" :prop="data.identity">
        </el-table-column>
      </el-table>
      <div class="table-foot" style="text-align: right">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
</template>

<script>
import { getWePageStatisticList, wePageStatisticDownload } from '@/api/customer.js'
export default {
  name: 'weixinManage',
  data () {
    return {
      headerList: [],
      scenedatalist: [],
      page: 1,
      limit: 10,
      totalCount: 0
    }
  },
  mounted () {
  },
  methods: {
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      this.page = page
      this.load()
    },
    // load
    load() {
      let id = this.$route.query.id
      getWePageStatisticList(id, this.page, this.limit).then((res) => {
        if (res.data.code === 0) {
          this.headerList = res.data.data.header
          this.scenedatalist = res.data.data.list
          this.totalCount = res.data.data.count
        } else {
          _g.toastMsg('error', res.data.msg)
        }
      })
    },
    // 下载
    downloadNow() {
      let id = this.$route.query.id
      wePageStatisticDownload(id).then(res => {
        this.download(res)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    }
  },
  created() {
    this.load()
  }
}
</script>

<style scoped>
</style>
